<template>
  <div id="app">
    <Heade v-if="showHF" />
    <router-view id="iv-mian-container" :style="mainstyle"/>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Heade from '@/page/header'
import Footer from '@/page/footer'
import store from '@/store'
export default {
  name: 'App',
  methods: {
    ...mapMutations({
      skin: 'SKIN'
    }),
    setMinheight () {
      let height = (document.documentElement.offsetHeight || document.body.offsetHeight) - 222
      this.mainstyle['min-height'] = height + 'px'
    },
    showDom () {
      //todo  修改为全局配置
      for (let item of store.state.hideRouterName) {
        if (this.$route.path === '/' || this.$route.path.indexOf(item) > -1) {
          this.showHF = false
          return
        }
      }
      this.showHF = true
    },
    setBg () {
      let bodtDom = document.getElementsByTagName('body')[0]
      for (let item in store.state.bgRouter) {
        for (let i of store.state.bgRouter[item]) {
          if (this.$route.path.indexOf(i) > -1) {
            bodtDom.style.background = item
            return
          }
        }
      }
      bodtDom.style.background = '#fff'
    }
  },
  data () {
    return {
      mainstyle: {
        'min-height': '100%'
      },
      bgstyle: {
        'background': '#fff'
      },
      showHF: true
    }
  },
  mounted () {
    window.onresize = () => {
      this.setMinheight()
    }
  },
  watch: {
    '$route' () {
      this.setMinheight()
      this.showDom()
      this.setBg()
    }
  },
  components: {
    Heade,
    Footer
  }
}
</script>
<style lang="scss">
/*全局样式注入*/
@import '@/static/lib/css/base/index.scss';
body,html,#app {
  height: 100%;
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    //overflow-x: hidden;
    // background: #f5f7f9;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue